module.exports = "https://static.energy5.com/_next/static/images/startProjectImage-29d65f9d4a8f40972a6cfda87235cb25.jpg";